module.exports = __webpack_public_path__ + "static/media/trend-portfolio bg2.ee9950c7.png";